var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCuteGmail = function SvgCuteGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 42,
    x: 3,
    y: 9,
    fill: "#faefde",
    rx: 4,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#efd8be",
    d: "M11 51V22l21 15-21 14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff7f0",
    d: "M32 28 6 9h52L32 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed7899",
    d: "M31.58 28 7.78 10.51A3 3 0 0 0 3 12.93V47a4 4 0 0 0 4 4h4V22l20.67 15L53 22v29h4a4 4 0 0 0 4-4V12.83a3 3 0 0 0-4.74-2.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M57 8H7a5 5 0 0 0-5 5v34a5 5 0 0 0 5 5h50a5 5 0 0 0 5-5V13a5 5 0 0 0-5-5Zm-1.85 2L32.59 26.34a1 1 0 0 1-1.17 0L8.85 10ZM12 48a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1V23.75L30.24 37a3 3 0 0 0 3.52 0L52 23.75V44a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v2H12Zm48-1a3 3 0 0 1-3 3h-3V21.79a1 1 0 0 0-1.59-.79L32.59 35.34a1 1 0 0 1-1.17 0L11.59 21a1 1 0 0 0-1.59.81V50H7a3 3 0 0 1-3-3V13a3 3 0 0 1 1.79-2.74L30.24 28a3 3 0 0 0 3.52 0l24.45-17.7A3 3 0 0 1 60 13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M17 44a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1z"
  })));
};
export default SvgCuteGmail;